var styles = {"pill-container":"styles_pill-container__GQUdX flex flex-wrap mx-auto my2 justify-center","pillContainer":"styles_pill-container__GQUdX flex flex-wrap mx-auto my2 justify-center"};

export default styles;
//# sourceMappingURL=styles.css.js.map
